<template>
  <div class="boxCenter">
    <div class="searchBox">
      <el-input
        placeholder="找人才，找项目，就来中一鼎合造价众包平台"
        placeholder-class="placeholderClass"
        v-model="searchText"
        @keyup.enter.native="searchTap"
      >
        <i
          slot="prefix"
          class="el-input__icon el-icon-search"
          style="color: #185ba1"
        ></i>
        <template slot="append">
          <el-button
            type="primary"
            style="background-color: #185ba1"
            @click="searchTap"
            >搜索</el-button
          >
        </template>
      </el-input>
    </div>
    <div class="sxxBox">
      <el-form
        label-position="right"
        label-width="80px"
        :model="formLabelAlign"
      >
        <div class="mingHeind">
          <el-form-item label="专业" class="mingHeind">
            <template>
              <div class="" style="display: flex">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="specCheckAll"
                  @change="speckAllChange"
                  >全选
                </el-checkbox>
                <div style="width: 20px"></div>
                <div style="flex: 1">
                  <el-checkbox-group v-model="specCheck" @change="speckChange">
                    <el-checkbox
                      v-for="(item, index) in majorList"
                      :label="item"
                      :key="index + 'b'"
                    >
                      {{ item.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="地区" class="mingHeind">
            <template>
              <template>
                <div class="" style="display: flex">
                  <el-checkbox
                    :indeterminate="isIndeterminate2"
                    v-model="addCheckAll"
                    @change="addAllChange"
                    >全选
                  </el-checkbox>
                  <div style="width: 20px"></div>
                  <div style="flex: 1">
                    <el-checkbox-group v-model="addCheck" @change="addChange">
                      <el-checkbox
                        v-for="(item, index) in addList"
                        :label="item"
                        :key="index + 'v'"
                      >
                        {{ item.cityName }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </template>
            </template>
          </el-form-item>
          <el-form-item label="服务费" class="mingHeind">
            <template>
              <template>
                <div class="" style="display: flex">
                  <div style="flex: 1" class="box">
                    <el-radio-group v-model="radio" @change="sevChange">
                      <el-radio
                        class="radio"
                        v-for="(item, index) in sevList"
                        :label="item"
                        :key="index + 'l'"
                        >{{ item.money }}</el-radio
                      >
                      <el-input
                        v-model="start"
                        style="display: inline; margin-left: 5px"
                        @blur="startChange"
                      ></el-input>
                      <span style="margin-left: 5px">-</span>
                      <el-input
                        v-model="end"
                        style="display: inline; margin-left: 10px"
                        @blur="endChange"
                      ></el-input>
                    </el-radio-group>
                  </div>
                </div>
              </template>
            </template>
          </el-form-item>

          <el-form-item label="交付时间" class="mingHeind">
            <template>
              <template>
                <div class="" style="display: flex">
                  <div style="flex: 1">
                    <el-radio-group v-model="timeCheck" @change="timeChange">
                      <el-radio
                        v-for="(item, index) in timeList"
                        :label="item"
                        :key="index + 'o'"
                        >{{ item.time }}</el-radio
                      >
                    </el-radio-group>
                  </div>
                </div>
              </template>
            </template>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="listbox">
      <div
        class="listLines list1 wzk-cursor"
        @click="toDetails(item)"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="names line2">
          {{ item.regionFy }}/{{ item.typeFy }}
          <template>
            <span v-for="(row, index) in item.majorFy" :key="index + 'q'"
              >/{{ row.name }}</span
            >
          </template>
          <span> /总投资:￥{{ item.totalInvestment || "00" }} </span>
          <span> /总规模:{{ item.totalScale }}m² </span>
          /{{ item.serviceContentFy }}
        </div>
        <div class="tagsBox">
          <el-tag type="info" class="tags">{{ item.regionFy }}</el-tag>
          <el-tag type="info" class="tags" v-if="item.necessary == 1"
            >需要出现场</el-tag
          >
          <el-tag type="info" class="tags" v-if="item.provided == 1"
            >提供CAD图纸</el-tag
          >
          <el-tag type="info" class="tags">{{ item.typeFy }}</el-tag>
          <template>
            <el-tag
              type="info"
              class="tags"
              v-for="(row, index) in item.majorFy"
              :key="index + 'w'"
              >{{ row.name }}
            </el-tag>
          </template>
          <el-tag type="info" class="tags" v-if="item.serviceContentFy">{{
            item.serviceContentFy
          }}</el-tag>
          <template>
            <el-tag
              type="info"
              class="tags"
              v-for="(row, index) in item.softwareFy"
              :key="index + 'e'"
              >{{ row.label }}
            </el-tag>
          </template>
        </div>
        <div class="priceOrStatus">
          <span v-if="item.typeAB == 'A'" class="prices">
            总规模：{{ item.totalScale }}m²
          </span>
          <span v-else class="prices">
            总投资：￥{{ item.totalInvestment }}
          </span>
            &nbsp;
          <span  class="prices">
            工程师收益：￥{{item.earningsAmount}}
          </span>
          <!-- <span class="prices w-m-l-20" v-if="item.profitType==2">
            固定总价
          </span> -->
          <!-- <span class="status">
            工程师报名中
          </span> -->
          <span v-if="item.status == 3" class="proj-state on-sign-up"
            >工程师报名中</span
          >
          <span v-if="item.status == 4" class="proj-state on-conduct"
            >项目进行中</span
          >
          <span v-if="item.status == 5" class="proj-state is-completed"
            >圆满完成</span
          >
        </div>
        <div class="times">交付时间：{{ item.engineerDeadline }}</div>
      </div>
      <div
        class="mdx-flex mdx-row-center queryParamss"
        style="margin-top: 30px"
        v-if="list.length"
      >
        <el-pagination
          :pageSize="queryParams.limit"
          :currentPage="queryParams.page"
          background
          layout="prev, pager, next"
          @current-change="pageChange"
          :page-count="queryParams.totalPage || 1"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import comData from "../../common/commonData.js";
import addOptions from "../../api/area.js";
import { getCustomType, initNumberValue } from "@/common/utils/num-validate.js";
export default {
  data() {
    return {
      searchText: "",
      formLabelAlign: {},
      start: "",
      end: "",
      specCheck: [],
      specCheckAll: false,
      majorList: [],
      //
      addCheck: [],
      addCheckAll: [],
      addList: [],

      list: [],
      queryParams: {
        page: 1, //当前页数
        limit: 10, //每页条数
        totalPage: 1,
      },
      isIndeterminate: false,
      isIndeterminate2: false,
      //服务费
      sevVal: "",
      radio: 0,
      sevList: [
        {
          cost: "全选",
          money: "全选",
          id: 1,
        },
        {
          cost: "0-1000",
          money: "0元-1000元",
          id: 2,
        },
        {
          cost: "1000-2000",
          money: "1000元-2000元",
          id: 3,
        },
        {
          cost: "2000-4000",
          money: "2000元-4000元",
          id: 4,
        },
        {
          cost: "4000-6000",
          money: "4000元-6000元",
          id: 5,
        },
        {
          cost: "6000",
          money: "6000元以上",
          id: 6,
        },
        {
          cost: "",
          money: "自定义",
          id: 7,
        },
      ],
      //交付时间
      timeId: null,
      timeCheck: 0,
      timeList: [
        {
          id: 5,
          time: "全选",
        },
        {
          id: 1,
          time: "7天内",
        },
        {
          id: 2,
          time: "7-21天",
        },
        {
          id: 3,
          time: "21-60天",
        },
        {
          id: 4,
          time: "60天以上",
        },
      ],
      ischeck: "",
    };
  },
  created() {
    this.$http.get("region/list").then((res) => {
      if (res.code == 200) {
        this.addList = res.data;
      } else {
        this.$message.error("地址获取失败");
      }
    });
    //专业类型获取
    this.$http.get("dict_data/getMajors").then((res) => {
      if (res.code == 200) {
        this.majorList = res.data;
      } else {
        this.$message.error("专业获取失败");
      }
    });
    this.getList();
    this.setKeyWords();
  },
  methods: {
    searchTap() {
      console.log(111);
      this.queryParams.page = 1;
      this.getList();
    },
    //
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.8)",
      });
      let major = [];
      let region = [];
      this.specCheck.forEach((e) => {
        major.push(e.id);
      });
      this.addCheck.forEach((e) => {
        region.push(e.code);
      });
      let start = null;
      let end = null;
      if (this.sevVal != "") {
        start = this.sevVal.split("-")[0];
        end = this.sevVal.split("-")[1];
      }
      this.$http
        .post("project/list", {
          pageNum: this.queryParams.page,
          pageSize: this.queryParams.limit,
          major: major,
          region: region,
          qname: this.searchText,
          dateType: this.timeId,
          incomeStart: start,
          incomeEnd: end,
        })
        .then((res) => {
          if (res.code == 200) {
            this.queryParams.totalPage = res.data.pages;
            res.data.list.forEach(function (item) {
              item.typeAB = getCustomType(item.type);
              item.totalInvestment = initNumberValue(item.totalInvestment); //总投资(元)
              item.totalScale = initNumberValue(item.totalScale); //总规模（m2）
            });
            this.list = res.data.list;
          } else {
            this.list = [];
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    pageChange(e) {
      this.queryParams.page = e;
      this.getList();
    },
    toDetails(item) {
      this.$mHelper.to("/hallDetail?id=" + item.id);
    },
    //专业
    speckAllChange(val) {
      this.specCheck = val ? this.majorList : [];
      this.isIndeterminate = false;
      this.queryParams.page = 1;
      this.getList();
    },
    speckChange(value) {
      this.queryParams.page = 1;
      let checkedCount = value.length;
      this.specCheckAll = checkedCount === this.majorList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.majorList.length;
      this.getList();
    },
    //地区
    addAllChange(val) {
      this.addCheck = val ? this.addList : [];
      this.isIndeterminate2 = false;
      this.queryParams.page = 1;
      this.getList();
    },
    addChange(value) {
      this.queryParams.page = 1;
      let checkedCount = value.length;
      this.specCheckAll = checkedCount === this.addList.length;
      this.isIndeterminate2 =
        checkedCount > 0 && checkedCount < this.addList.length;
      this.getList();
    },
    //服务费
    sevChange(value) {
      this.ischeck = value;
      if (value.id != 7) {
        this.start = "";
        this.end = "";
      }
      if (value.id != 1) {
        this.sevVal = value.cost;
      } else {
        this.sevVal = "";
      }
      if (value.id == 7 && this.start != "" && this.end != "") {
        value.cost = this.start + "-" + this.end;
        this.sevVal = value.cost;
      } else if (value.id == 7 && this.start == "" && this.end == "") {
        return;
      }
      this.queryParams.page = 1;
      this.getList();
    },
    //交付时间
    timeChange(value) {
      if (value.id != 5) {
        this.timeId = value.id;
      } else {
        this.timeId = null;
      }
      this.queryParams.page = 1;
      this.getList();
    },
    setKeyWords() {
      let element = document.getElementsByTagName("meta");
      let elementArr = Array.from(element);
      let keyWordMeta = elementArr.find((item) => item.name == "keywords");
      if (keyWordMeta) {
        keyWordMeta.content =
          "中一鼎合项目,中一鼎合做的项目有哪些,房建土建,钢结构,精装修,幕墙,房建安装,市政土建,市政管网,市政电气,市政智能化,工程量计算,编清单,组价,概算,住宅,公寓,别墅,学校,医疗建筑,宾馆酒店,交通枢纽,场馆,商业,办公,厂房,物流仓储,地下室,污水处理厂,自来水厂,变电站,加油站,热力站,公交场站,垃圾站,公厕,市政工程,广联达,斯维尔,鲁班,品茗,宏业,新点,一点智慧,智多星,算王,晨曦,广龙,易达,博奥,福莱,造价项目";
      }
    },
    startChange() {
      if (this.ischeck.id == 7) {
        this.sevVal = this.start + "-" + this.end;
        this.getList();
      }
    },
    endChange() {
      if (this.ischeck.id == 7) {
        this.sevVal = this.start + "-" + this.end;
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  ::v-deep .el-input__inner {
    width: 50px;
    height: 26px;
    padding: 0 6px;
  }
  .el-radio-group {
    font-size: 15px;
    ::v-deep .el-radio {
      margin-right: 0 !important;
      margin-left: 30px;
    }
    ::v-deep .el-radio:first-child {
      margin-left: 0;
    }
  }
}
.listbox {
  background-color: #fff;
  padding: 0 40px;
  padding-bottom: 30px;
  margin-top: 30px;
}

.listLines {
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  // margin-top: 20px;
  background-color: #fff;
  padding: 20px 0;
  box-sizing: border-box;

  .names {
    font-size: 16px;
  }

  .times {
    font-size: 14px;
    color: #757575;
  }

  .tags {
    background: #eeeeee;
    color: #757575;
    margin-right: 15px;
    height: 28px;
    line-height: 28px;
  }
}

.list1 {
  .times {
    font-size: 14px;
    color: #757575;
  }

  .tagsBox {
    margin-top: 10px;
  }

  .priceOrStatus {
    line-height: 50px;

    .prices {
      font-size: 18px;
      font-weight: 550;
      color: #ff3b30;
    }

    .status {
      margin-left: 30px;
      font-size: 14px;
      color: #ff3b30;
    }
  }
}

.sxxBox {
  border-radius: 4px;
  box-shadow: 0 0 10px #eee;
  padding-top: 20px;
  padding-bottom: 1px;
  box-sizing: border-box;
  background-color: #fff;
}

.mingHeind {
  ::v-deep .el-form-item__content {
    line-height: 20px;
  }

  ::v-deep .el-form-item__label {
    line-height: 20px;
  }
}

.searchBox {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;

  .placeholderClass {
    color: #185ba1;
  }

  ::v-deep .el-input-group {
    width: 700px;
  }

  ::v-deep .el-input__inner {
    color: #185ba1;
    border: 1px solid #185ba1;
  }

  ::v-deep .el-input-group__append {
    border: 1px solid #185ba1;
    background-color: #185ba1;
  }

  ::v-deep ::-webkit-input-placeholder {
    color: #185ba1;
  }

  ::v-deep ::-moz-input-placeholder {
    color: #185ba1;
  }

  ::v-deep ::-ms-input-placeholder {
    color: #185ba1;
  }
}

.proj-state {
  margin-left: 30px;
  font-size: 14px;
}

.on-sign-up {
  color: #ff3b30;
}

.on-conduct {
  color: #757575;
}

.is-completed {
  color: #757575;
}
</style>
